import useGetCompanyAddresses from '../../addresses/hooks/useGetCompanyAddresses'
import useGetCompanyInfo from './useGetCompanyInfo'

export default () => {
  const { isLoading: isLoadingCompanyAddresses } = useGetCompanyAddresses()
  const { isLoading: isLoadingCompanyInfo } = useGetCompanyInfo()

  return isLoadingCompanyAddresses || isLoadingCompanyInfo
}
